/**
 * Central brand + domain config.
 *
 * Rebranding needs NO source edit: set the build-time env vars
 *   VITE_APP_NAME        e.g. "Acme German"
 *   VITE_MAIN_DOMAIN     e.g. "acme.com"
 *   VITE_SUPPORT_EMAIL   e.g. "hello@acme.com"  (optional; defaults to sales@<domain>)
 * (in CI: repo variables; locally: an untracked frontend/.env.local).
 * Unset falls back to the Discentem defaults below.
 *
 * The API base URL is intentionally NOT here — the SPA calls the relative
 * `/api/v1` on whatever host it is served from (see api/http.ts), so it is
 * already domain-agnostic and Front Door routes /api to the backend.
 */
const env = import.meta.env as Record<string, string | undefined>;

export const MAIN_DOMAIN: string = env.VITE_MAIN_DOMAIN || "discentem.com";
export const APP_NAME: string = env.VITE_APP_NAME || "Discentem";
export const SUPPORT_EMAIL: string =
  env.VITE_SUPPORT_EMAIL || `sales@${MAIN_DOMAIN}`;
